
import React, { createContext, useContext } from 'react';
import { MemberFetcher, EditorContextType, NodeData } from './types';
import { Building, Users, Layout, Shield, User } from 'lucide-react';

// Default Icons
export const DefaultIcons: Record<string, any> = {
  Building,
  Users,
  Layout,
  Shield,
  User,
  Group: Users
};

const EditorContext = createContext<EditorContextType>({
  iconMap: DefaultIcons
});

export const useEditorContext = () => useContext(EditorContext);

export const EditorContextProvider: React.FC<{
  children: React.ReactNode;
  onFetchMembers?: MemberFetcher;
  iconMap?: Record<string, any>;
  onRemoveEdge?: (edgeId: string) => void;
  onUpdateNode?: (nodeId: string, data: Partial<NodeData>) => void;
}> = ({ children, onFetchMembers, iconMap, onRemoveEdge, onUpdateNode }) => {
  const finalIcons = { ...DefaultIcons, ...iconMap };
  return (
    <EditorContext.Provider value={{ onFetchMembers, iconMap: finalIcons, onRemoveEdge, onUpdateNode }}>
      {children}
    </EditorContext.Provider>
  );
};
